import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: '2rem',
    flexDirection: 'column',
    display: 'flex',
    gap: '2rem',

    [$theme.mediaQuery.large]: {
        width: '40rem',
        margin: '2rem auto'
    }
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    fontWeight: 700,
    margin: 0
}))
